import React from 'react';
import { FormContainer } from 'vetrf-ui';
import { ExtendedQuery } from 'components/registry/types/api';
import { FiltersButtons } from 'components/registry/components/FiltersWrapper/FiltersButtons';
import { useFiltersContext } from 'components/FiltersContext/context';
import { FeedRegistryParams } from '../../../api/params';
import { normalizeRegistryFilters } from '../utils';
import { FeedRegistryFilter } from '../types';
import { RegistryFiltersFields } from './RegistryFiltersFields';

type RegistryFiltersProps = {
  onFiltersChange: (item: ExtendedQuery<FeedRegistryParams>) => void;
};

export const RegistryFilters = ({ onFiltersChange }: RegistryFiltersProps) => {
  const { handleSetFilters } = useFiltersContext();

  const handleSubmit = (values: FeedRegistryFilter) => {
    const formattedValues = normalizeRegistryFilters(values);
    handleSetFilters({ feedRegistry: values });
    onFiltersChange({ extendedQuery: formattedValues });
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <RegistryFiltersFields />
      <FiltersButtons
        onReset={handleSubmit}
        selectResetList={['name', 'vendor', 'producer']}
        filterName="feedRegistry"
      />
    </FormContainer>
  );
};
